/* Shop by Category JS */
(function(){
  const CLASS_SECTION = 'shop-by-category';
  const MOBILE_MAX = 1199; // slider active only up to 1199px
  let swiperLibLoading = false;

  function initMobileSwiper(section){
    if(!section) return;
    if(section.getAttribute('data-mobile-swiper') !== 'true') return;
    if(!window.matchMedia(`(max-width: ${MOBILE_MAX}px)`).matches) return;
    if(section.__swiperInited) return;
    const container = section.querySelector('.swiper-container');
    if(!container) return;

    function create(){
      if(typeof Swiper === 'undefined') return;
      section.__swiperInited = true;
      section.__swiperInstance = new Swiper(container, {
        slidesPerView: 2, // exact 2 cards on small mobile
        spaceBetween: 16,
        resistanceRatio: 0.6,
        freeMode: false,
        loop: true,
        loopAdditionalSlides: 5,
        watchOverflow: true,
        breakpoints: {
          480: { slidesPerView: 2, spaceBetween: 20 },
          640: { slidesPerView: 2.5, spaceBetween: 24 }
        }
      });
    }

    if(typeof Swiper === 'undefined') {
      if(!swiperLibLoading){
        swiperLibLoading = true;
        const l = document.createElement('link');
        l.rel='stylesheet';
        l.href='https://cdn.jsdelivr.net/npm/swiper@9/swiper-bundle.min.css';
        document.head.appendChild(l);
        const s = document.createElement('script');
        s.src='https://cdn.jsdelivr.net/npm/swiper@9/swiper-bundle.min.js';
        s.onload=create;
        document.head.appendChild(s);
      } else {
        const iv = setInterval(function(){ if(typeof Swiper !== 'undefined'){ clearInterval(iv); create(); } },120);
        setTimeout(function(){ clearInterval(iv); },5000);
      }
    } else {
      create();
    }
  }
  function initSection(section){
    if(!section || section.dataset.sbcatInit) return; section.dataset.sbcatInit='1';
    const cards = section.querySelectorAll('.shop-by-category__card');
    const preloadList=[];
    cards.forEach(card=>{ const h=card.dataset.hoverSrc; if(h){ preloadList.push(h);} });
    preload(preloadList);
    initMobileSwiper(section);
  }
  function preload(urls){ urls.forEach(u=>{ const i=new Image(); i.decoding='async'; i.loading='eager'; i.src=u; }); }
  function destroySwiper(section){
    if(section && section.__swiperInstance){
      try { section.__swiperInstance.destroy(true,true); } catch(e){}
      section.__swiperInstance = null;
      section.__swiperInited = false;
    }
  }
  function scan(){ document.querySelectorAll('.'+CLASS_SECTION).forEach(initSection); }
  if(document.readyState==='loading'){ document.addEventListener('DOMContentLoaded',scan); } else { scan(); }
  document.addEventListener('shopify:section:load', e=>{ const s=e.target.querySelector('.'+CLASS_SECTION); if(s) initSection(s); });
  window.addEventListener('resize', ()=>{
    const isMobileRange = window.matchMedia(`(max-width: ${MOBILE_MAX}px)`).matches;
    document.querySelectorAll('.'+CLASS_SECTION).forEach(sec=>{
      if(isMobileRange){
        if(!sec.__swiperInited) initMobileSwiper(sec);
      } else {
        if(sec.__swiperInited) destroySwiper(sec);
      }
    });
  });
})();
